<template>
  <v-container id="day" fluid class="fill-height align-start pa-0">
    <v-row class="ma-0">
      <v-col class="pa-0" v-for="(taskTypeGroup, index) in taskTypeGroups" :key="index">
        <div class="coloured d-flex justify-space-between pa-2" :class="taskTypeGroup.name">
          <div :class="taskTypeGroup.name">
            {{ taskTypeGroup.label }}
          </div>
          <v-spacer />
          <div class="count">
            {{ getDailyUnitsByType(taskTypeGroup.name) }}
          </div>
          <div v-if="['cut', 'finish', 'pack', 'dispatch'].includes(taskTypeGroup.name)">
            <span class="mx-1">/</span>{{ getDailyMegaUnitsByType(taskTypeGroup.name) }} mµ
          </div>
        </div>
        <div
          class="task text-body-2"
          v-for="(task, key) in tasksOfType(tasks, taskTypeGroup)"
          :class="[
            task.type,
            $utils.camelize(task.subtype),
            { coloured: !task.complete && !task.paused },
            { paused: task.paused }
          ]"
          :id="task.id"
          @click="$emit('openTask', task)"
          style="flex-direction: column"
          :key="key"
        >
          <div class="d-flex justify-space-between">
            <div>{{ task.customerEmail }}</div>
            <v-spacer />
            <div>
              {{ task.units }}
            </div>
            <div v-if="['cut'].includes(task.type) && task.muCut">
              <span class="mx-1">/</span>{{ $utils.toFixedNumber(task.muCut, 1) }} mµ
            </div>
            <div v-else-if="['finish', 'assemble'].includes(task.type) && task.muFinish">
              <span class="mx-1">/</span>{{ $utils.toFixedNumber(task.muFinish, 1) }} mµ
            </div>
            <div v-else-if="['pack'].includes(task.type) && task.muPack">
              <span class="mx-1">/</span>{{ $utils.toFixedNumber(task.muPack, 1) }} mµ
            </div>
            <div v-else-if="['dispatch'].includes(task.type) && task.muDispatch">
              <span class="mx-1">/</span>{{ $utils.toFixedNumber(task.muDispatch, 1) }} mµ
            </div>
            <v-icon class="ml-1" v-if="task.complete" size="small">mdi-check</v-icon>
          </div>
          <div class="d-flex justify-space-between align-end">
            <div class="mr-2">
              <v-icon
                v-if="task.type === 'cut' && !task.toolpathed && !task.repeatTaskId"
                :size="14"
                :style="{
                  'padding-bottom': '1px',
                  'padding-right': '3px',
                  color: task.complete ? 'black' : 'white'
                }"
                >mdi-alert</v-icon
              >
              <v-icon
                v-if="
                  task.type === 'dispatch' &&
                  task.subtype === 'To customer' &&
                  task.courierBooked &&
                  !task.complete &&
                  !task.repeatTaskId
                "
                :size="15"
                :color="isShipmentPropertyTrue(task.shipmentID, 'balanceOutstanding') ? 'orange' : 'white'"
                >mdi-truck-check</v-icon
              >
              {{ task.orderNumber || task.invoiceNumber }}
            </div>
            <div class="text-right">
              {{ task.objectType }}
              {{ task.subtype ? task.subtype : task.type }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Day',
  props: ['taskTypeGroups', 'tasksByDay', 'today', 'isShipmentPropertyTrue'],
  computed: {
    tasks() {
      return this.tasksByDay[this.today]
    }
  },
  methods: {
    // Replaces `v-if` on the same element as `v-for`, which throws in Vue 3.
    tasksOfType(tasks, taskTypeGroup) {
      return (tasks || []).filter((task) => taskTypeGroup.types.indexOf(task.type) >= 0)
    },
    getDailyUnitsByType(type) {
      if (!this.tasks) return 0
      var units = 0
      for (const task of this.tasks) {
        if (task.type == type) {
          units += parseInt(task.units)
        }
      }
      return units
    },
    getDailyMegaUnitsByType(type) {
      if (!this.tasks) return 0
      let mu = 0
      for (const task of this.tasks) {
        // add cut mu total
        if (['cut'].includes(task.type) && type == 'cut') {
          mu += task?.muCut ? task?.muCut : 0
        }
        // add assemble mu to finish mu total
        if (['finish', 'assemble'].includes(task.type) && type == 'finish') {
          mu += task?.muFinish ? task?.muFinish : 0
        }
        // add pack mu total
        if (['pack'].includes(task.type) && type == 'pack') {
          mu += task?.muPack ? task?.muPack : 0
        }
        // add dispatch mu total
        if (['dispatch'].includes(task.type) && type == 'dispatch') {
          mu += task?.muDispatch ? task?.muDispatch : 0
        }
      }
      mu = this.$utils.toFixedNumber(mu, 1)
      return mu
    }
  }
}
</script>

<style lang="scss" scoped>
#day {
  width: 100%;
  transition: width 0.5s;
  .row {
    height: 100%;
    .col {
      border-right: solid 1px $ruleGrey;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
